import React from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Box,
  Divider,
} from "@chakra-ui/react";
import { PageTabTitle } from "./PageTabTitle";

interface StakingSectionItemProps {
  title: string;
  body: React.ReactNode;
  trackTabClickEvent?: () => void;
}

interface StakingSectionProps {
  tabdata: StakingSectionItemProps[];
}

export const StakingSection = ({ tabdata }: StakingSectionProps) => {
  return (
    <Box
      bg="brand.backgroundLight"
      boxShadow="0px 4px 12px rgba(53, 56, 140, 0.05)"
      borderRadius="0.5rem"
      p={{ base: "0.75rem", md: "1.5rem" }}
      height="fit-content"
    >
      <Tabs isFitted variant="unstyled" p="0" defaultIndex={0} isLazy>
        <TabList fontWeight="500" color="brand.textInactive">
          {tabdata.map((t, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <Box height="1.75rem" position="relative" top="0.75rem">
                  <Divider
                    orientation="vertical"
                    borderColor="brand.separator"
                  />
                </Box>
              )}
              <PageTabTitle
                title={t.title}
                trackTabClickEvent={t.trackTabClickEvent}
              />
            </React.Fragment>
          ))}
        </TabList>

        <TabPanels>
          {tabdata.map((t, i) => (
            <TabPanel mt="1rem" px="0" pb="0" key={i}>
              {t.body}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
